import { useCart as hydrogenUseCart } from '@shopify/hydrogen-react';

/**
 - Note: This conditionally calls a hook, which technically violates the Rules of Hooks.
   In practice it’s a pragmatic SSR workaround. Prefer fixing SSR (e.g., aliasing
   use-isomorphic-layout-effect) when possible.
*/
export type SafeCart = ReturnType<typeof hydrogenUseCart>;

const ssrStub = {
    status: 'uninitialized',
    error: undefined,
    cart: undefined,
    totalQuantity: 0,
    lines: [],
    checkoutUrl: undefined,
    note: undefined,
    buyerIdentity: undefined,
    cost: undefined,
    // No-op async actions; resolve to undefined-like payloads
    linesAdd: async () => ({ cart: undefined }),
    linesRemove: async () => ({ cart: undefined }),
    linesUpdate: async () => ({ cart: undefined }),
    cartAttributesUpdate: async () => ({ cart: undefined }),
    noteUpdate: async () => ({ cart: undefined }),
    buyerIdentityUpdate: async () => ({ cart: undefined }),
    discountCodesUpdate: async () => ({ cart: undefined }),
    cartCreate: async () => ({ cart: undefined }),
    cartFetch: async () => ({ cart: undefined }),
    cartSetId: () => { },
    cartGetId: () => undefined,
} as unknown as SafeCart;

export function useClientOnlyCart(): SafeCart {
    if (typeof window === 'undefined') return ssrStub;
    return hydrogenUseCart();
}